var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2914 0C11.1854 0 12.0454 0.353333 12.678 0.987333C13.3114 1.62 13.6654 2.47333 13.6654 3.36667V8.63333C13.6654 10.4933 12.152 12 10.2914 12H3.70536C1.8447 12 0.332031 10.4933 0.332031 8.63333V3.36667C0.332031 1.50667 1.83803 0 3.70536 0H10.2914ZM11.0454 3.46667C10.9054 3.45933 10.772 3.50667 10.6714 3.6L7.66537 6C7.2787 6.32067 6.7247 6.32067 6.33203 6L3.33203 3.6C3.1247 3.44667 2.83803 3.46667 2.66536 3.64667C2.48536 3.82667 2.46536 4.11333 2.61803 4.31333L2.70536 4.4L5.7387 6.76667C6.11203 7.06 6.5647 7.22 7.0387 7.22C7.51137 7.22 7.97203 7.06 8.3447 6.76667L11.352 4.36L11.4054 4.30667C11.5647 4.11333 11.5647 3.83333 11.398 3.64C11.3054 3.54067 11.178 3.48 11.0454 3.46667Z",
    fill: "#43474F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.a0fcc4168921198379294c29311cc96f.svg";
export { ForwardRef as ReactComponent };